import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function AuthPage() {
  const [mode, setMode] = useState('login')
  const [form, setForm] = useState({ name: '', email: '', password: '', college: '', department: '', role: 'professor' })
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState({ text: '', type: '' })

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value })

  const login = async () => {
    setLoading(true); setMsg({})
    const { error } = await supabase.auth.signInWithPassword({ email: form.email, password: form.password })
    if (error) setMsg({ text: error.message, type: 'err' })
    setLoading(false)
  }

  const signup = async () => {
    setLoading(true); setMsg({})
    const { error } = await supabase.auth.signUp({
      email: form.email, password: form.password,
      options: { data: { name: form.name, college: form.college, department: form.department, role: form.role } }
    })
    if (error) setMsg({ text: error.message, type: 'err' })
    else setMsg({ text: 'Email confirm karo inbox mein! Phir login karo.', type: 'ok' })
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #f8f7ff 0%, #fff0f0 100%)' }}>
      <div style={{ background: '#fff', border: '1px solid #e8e6ff', borderRadius: 20, padding: '2rem', width: '100%', maxWidth: 440, boxShadow: '0 8px 32px rgba(162,45,45,0.08)' }}>

        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🛡️</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#A32D2D' }}>DisciplineTrack</div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 4 }}>College Discipline Management System</div>
        </div>

        <div style={{ display: 'flex', background: '#f3f2ff', borderRadius: 10, padding: 4, marginBottom: 20 }}>
          {['login', 'signup'].map(m => (
            <button key={m} onClick={() => { setMode(m); setMsg({}) }} style={{
              flex: 1, padding: '9px 0', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
              background: mode === m ? '#fff' : 'transparent', color: mode === m ? '#E24B4A' : '#888',
              boxShadow: mode === m ? '0 1px 6px rgba(0,0,0,0.1)' : 'none', transition: 'all 0.2s'
            }}>{m === 'login' ? '🔐 Login' : '📝 Register'}</button>
          ))}
        </div>

        {msg.text && (
          <div style={{ background: msg.type === 'ok' ? '#EAF3DE' : '#FCEBEB', color: msg.type === 'ok' ? '#3B6D11' : '#A32D2D', borderRadius: 10, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>
            {msg.text}
          </div>
        )}

        {mode === 'signup' && (
          <>
            <Field label="Aapka poora naam" name="name" value={form.name} onChange={handle} placeholder="Dr. Ramesh Sharma" />
            <Field label="College ka naam" name="college" value={form.college} onChange={handle} placeholder="Govt. College, Jabalpur" />
            <Field label="Department" name="department" value={form.department} onChange={handle} placeholder="Hindi Vibhag" />
            <div style={{ marginBottom: 14 }}>
              <label style={lbl}>Aap kaun hain?</label>
              <select name="role" value={form.role} onChange={handle} style={inp}>
                <option value="professor">Professor</option>
                <option value="principal">Principal / Admin</option>
              </select>
            </div>
          </>
        )}

        <Field label="Email address" name="email" type="email" value={form.email} onChange={handle} placeholder="professor@college.edu" />
        <Field label="Password" name="password" type="password" value={form.password} onChange={handle} placeholder="••••••••" />

        <button onClick={mode === 'login' ? login : signup} disabled={loading} style={{
          width: '100%', padding: '12px 0', borderRadius: 12, border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
          background: loading ? '#ccc' : 'linear-gradient(135deg, #E24B4A, #A32D2D)', color: '#fff', fontSize: 15, fontWeight: 700, marginTop: 4
        }}>
          {loading ? 'Please wait...' : mode === 'login' ? '🔐 Login Karo' : '🚀 Account Banao'}
        </button>
      </div>
    </div>
  )
}

const lbl = { fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }
const inp = { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e0deff', fontSize: 13, color: '#222', background: '#fafafe', fontFamily: 'inherit', boxSizing: 'border-box' }

function Field({ label, name, type = 'text', value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={lbl}>{label}</label>
      <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder} style={inp} />
    </div>
  )
}
